<template>
  <div>
    <vs-table :data="tradeDesktops">
      <template slot="thead">
        <vs-th>Desktop Name</vs-th>
        <vs-th>Desktop Status</vs-th>
        <vs-th>User ID</vs-th>
        <vs-th>Datacenter</vs-th>
        <vs-th>Location</vs-th>
        <vs-th>Sequence Number</vs-th>
        <vs-th>IP address</vs-th>
        <vs-th>Created at</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr v-for="desktop in data" :key="desktop.id">
          <!-- <vs-td>{{ desktop.vm_sequence_id }}</vs-td>
          -->
          <vs-td>{{ desktop.title }}</vs-td>
          <vs-td :class="{
            'bg-clip-text text-transparent bg-warning':desktop.vm_status == '1',
            'bg-clip-text text-transparent bg-orange-300':desktop.vm_status == '3',
            'bg-clip-text text-transparent bg-success':desktop.vm_status == '4',
            'bg-clip-text text-transparent bg-red-600':desktop.vm_status == '5'
          }
          ">{{ desktop.vm_status_title }}</vs-td>
          <vs-td>{{ $route.query.id || userId }}</vs-td>
          <vs-td>{{ desktop.datacenter.title }}</vs-td>
          <vs-td>{{ desktop.location.title }}</vs-td>
          <vs-td>{{ desktop.vm_sequence_id }}</vs-td>
          <vs-td>{{ desktop.local_ip_address }}</vs-td>
          <vs-td>{{ desktop.created_at }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
// import axios from 'axios';

export default {
  props: {
    userId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      tradeDesktops: []
    };
  },
  created() {
    this.fetchTradeDesktops();
  },
  methods: {
    async fetchTradeDesktops() {
      try {
        const response = await this.$http.get(`admin/cloud/desktop/trade?page&filter&location&user_id=${this.$route.query.id || this.userId}&with_deleted=0`);
        // console.log("RESPONSE: ",response);
        
        if (response.data.status) {
          this.tradeDesktops = response.data.params.data;
          this.$vs.notify({ text: response.data.message, color: 'success' });
        }
      } catch (error) {
        this.$vs.notify({ text: 'Error fetching trade desktops', color: 'danger' });
      }
    }
  }
};
</script>
